import React, { useEffect } from 'react';
import { useMutation } from '@apollo/react-components';

import _ from 'lodash';
import Banner from '@components/libraryV2/Banner';
import ContentWell from '@components/libraryV2/ContentWell';
import Disclaimer from '@components/directory/Disclaimer';
import Hero from '@components/libraryV2/Hero';
import Layout from '@components/layout';
import Pagination from '@components/libraryV2/Pagination';
import PassGuaranteedCta from '@components/libraryV2/PassGuaranteedCta';
import Seo from '@components/Seo';
import ThemeText from '@components/libraryV2/ThemeText';
import Tutor from '@components/libraryV2/Tutor';
import getCurrentYear from '@lib/getCurrentYear';
import { capitalize } from '@lib/helpers';
import LOG_EVENT from '@queries/logEvent';
import SEO_PRODUCT from '@constants/seoProduct';

import * as styles from './styles.module.scss';

export const Head = (props) => {
  const {
    location: { pathname },
    pageContext: { type },
  } = props;
  const level = type.split('-')[0];

  const seo = {
    canonical: pathname,
    description: `Get accepted by your dream school. Discover ${level} admissions counselors and former admissions officers. Craft the perfect application and outshine other candidates.`,
    keywords: `admissions, counselors, admissions counselors, ${level}, ${level} admissions counselors`,
    title: `${_.capitalize(level)} admissions counselors (${getCurrentYear()})`,
  };

  return <Seo seo={seo} />;
};

const AdmissionsCounselors = (props) => {
  const { pageContext } = props;
  const { basePath, type, counselors, page, totalPages } = pageContext;
  const [logEvent] = useMutation(LOG_EVENT);

  useEffect(() => {
    const logEventAsync = async () => {
      try {
        await logEvent({
          variables: {
            input: {
              object: `counselors--page-${page}`,
              objectType: type,
              productSlug: type,
            },
          },
        });
      } catch (e) {
        /* NOP */
      }
    };

    logEventAsync();
  }, []);

  const level = type.split('-')[0];
  const title = `${capitalize(level)} admissions`;
  const productType = level === 'graduate' ? 'gre' : 'act';
  const seoProduct = SEO_PRODUCT[productType];
  const { description, firstPage } = seoProduct;

  return (
    <Layout>
      <div className={styles.hero}>
        <Hero
          className={styles.heroContent}
          title={
            <div className={styles.heroTitle}>
              <ThemeText>{title}</ThemeText> <div>Counselor directory</div>
            </div>
          }
          withBackground
        />
      </div>

      <ContentWell size="dog" tighten>
        <Banner theme="badgePerson">
          <Disclaimer />
        </Banner>

        <div className={styles.pagination}>
          <div className={styles.counselors}>
            {counselors.map((counselor) => (
              <Tutor key={counselor.uuid} type={type} {...counselor} />
            ))}
          </div>
          <Pagination basePath={basePath} page={page} totalPages={totalPages} />
        </div>
      </ContentWell>

      <PassGuaranteedCta
        tagline={
          <>
            Hit your <ThemeText>target score</ThemeText>
          </>
        }
        detailText={description}
        href={firstPage}
        type={productType}
        noGuarantee
      />
    </Layout>
  );
};

export default AdmissionsCounselors;
